import { ENV } from '@/lib/config/env';
import { ROUTES } from '@/shared/config/routes';

/**
 * Opens a project in the external Asset Planner app in a NEW browser tab.
 *
 * Asset Planner is a separate deployment whose host is the platform host
 * prefixed with the `asset-planner.` subdomain (same derivation pattern as
 * shared/utils/flow-digest.ts):
 *   https://dev.monksflow.ai -> https://asset-planner.dev.monksflow.ai
 *   https://monksflow.ai     -> https://asset-planner.monksflow.ai
 */
export const openAssetPlanner = (workspaceId: string, platformProjectId: string): void => {
  const { protocol, hostname } = new URL(ENV.PLATFORM_BASE_URL);
  const workspaceSegment = encodeURIComponent(workspaceId);
  const projectSegment = encodeURIComponent(platformProjectId);
  window.open(
    `${protocol}//asset-planner.${hostname}/workspace/${workspaceSegment}/project/${projectSegment}`,
    '_blank',
    'noopener,noreferrer',
  );
};

/** Opens the new-project route in a NEW browser tab (origin-relative). */
export const openNewProject = (): void => {
  window.open(ROUTES.PROJECT_NEW, '_blank', 'noopener,noreferrer');
};
